// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._489kxt0 {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  background: white;
  border: 1px solid;
  border-color: var(--_18w76bw2a);
  cursor: pointer;
  z-index: var(--_18w76bw5b);
  position: absolute;
}
._489kxt1 {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
}
._489kxt2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--_18w76bwl);
  padding-left: var(--_18w76bwb);
  padding-right: var(--_18w76bwb);
  transition: background-color 250ms;
  background: white;
}
._489kxt2:hover {
  background-color: var(--_18w76bw29);
}
._489kxt2:not(:first-child) {
  border-top: 1px solid;
  border-color: var(--_18w76bw29);
}
._489kxt2[data-reach-menu-item][aria-disabled] {
  color: var(--_18w76bw2d);
  text-decoration: line-through;
}
._489kxt3 {
  background-color: var(--_18w76bw29);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC","sourcesContent":["._489kxt0 {\n  width: 280px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  background: white;\n  border: 1px solid;\n  border-color: var(--_18w76bw2a);\n  cursor: pointer;\n  z-index: var(--_18w76bw5b);\n  position: absolute;\n}\n._489kxt1 {\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n._489kxt2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: var(--_18w76bwl);\n  padding-left: var(--_18w76bwb);\n  padding-right: var(--_18w76bwb);\n  transition: background-color 250ms;\n  background: white;\n}\n._489kxt2:hover {\n  background-color: var(--_18w76bw29);\n}\n._489kxt2:not(:first-child) {\n  border-top: 1px solid;\n  border-color: var(--_18w76bw29);\n}\n._489kxt2[data-reach-menu-item][aria-disabled] {\n  color: var(--_18w76bw2d);\n  text-decoration: line-through;\n}\n._489kxt3 {\n  background-color: var(--_18w76bw29);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
